module.exports = __webpack_public_path__ + "static/media/ayush.10900724.jpg";